import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getApproverResultsData = createApi(`GetApproverResultsSlice`,"GET");

const GetApproverResultsSlice = createSlice({
  name: 'GetApproverResultsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getApproverResultsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getApproverResultsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getApproverResultsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetApproverResultsSlice.reducer;